import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetAllRolePermissionByRoleId,
  GetAllRolePermissions,
  LoginUser,
} from "../../Apis/loginApi"; 
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Captcha from "../../Captcha/Captcha";
import useCaptchaStore from "../../Captcha/useCaptchaStore";
import "./login.css";
import isGHMC from "../../Common/helper/helpar";

import loginLogo from "../../../assets/images/core-solid-logo.png";
import loginBgImage from "../../../assets/images/core-delhi-bg.png";
import LeftLogo from "../../../assets/images/delhi-left3.png";
import dustbinLogo from "../../../assets/images/dustbin-logo.png";
import logo1 from "../../../assets/images/municipal-logo.png";

const LoginForm = ({ updateLoginPermission, setIsLoggedIn, validPaths }) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const isProd = isGHMC();
  // const refreshString = () => {
  //   setCaptcha(Math.random().toString(36).slice(8));
  // };

  const [credentials, setCredentials] = useState({
    emailId: "",
    password: "",
  });
  const [fieldErrors, setFieldErrors] = useState({
    emailId: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20}$/;

  // const handleCaptchaChange = (text) => {
  //   setCaptcha(text);
  // };

  // const handleCaptchaRefresh = () => {
  //   captchaRef.current.refresh();
  //   setInputCaptcha("");
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const getPasswordValidationMessage = (password) => {
    if (!password) {
      return "Please enter your password.";
    }
    if (!passwordPattern.test(password)) {
      return "Password is invalid";
    }
    return "";
  };

  const validateLoginFields = () => {
    const nextErrors = { emailId: "", password: "" };
    const email = credentials.emailId.trim();
    const password = credentials.password;

    if (!email) {
      nextErrors.emailId = "Please enter your email.";
    } else if (!emailPattern.test(email)) {
      nextErrors.emailId = "Email is invalid";
    }

    nextErrors.password = getPasswordValidationMessage(password);

    setFieldErrors(nextErrors);
    return !nextErrors.emailId && !nextErrors.password;
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  // Set Cookie Token
  const setCookie = (key, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    // Set cookie for the root domain
    document.cookie = `${key}=${value || ""
      }${expires}; domain=.vmaxtechservices.life; path=/;`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateLoginFields()) {
      return;
    }

    if (!useCaptchaStore.getState().validateCaptchaInput()) {
      return;
    }

    setIsLoading(true);
    try {
      const userData = await LoginUser(credentials);
      const token = userData;

      setCookie("token", token, 7);
      const role = userData.role;
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      // Decode the token
      const decodedToken = jwtDecode(userData);
      const userName = decodedToken.name;
      localStorage.setItem("userName", userName);
      // // roleIDs
      const rolePermissions = await GetAllRolePermissionByRoleId(
        decodedToken.RoleId,
        {},
      );

      localStorage.setItem("rolePermissions", JSON.stringify(rolePermissions));
      const allPermissions = await GetAllRolePermissions();
      sessionStorage.setItem("permissionsData", JSON.stringify(allPermissions));
      const matchedPermissions = rolePermissions.map((rolePerm) => {
        const matchedPerm = allPermissions.find(
          (perm) => perm.permissionId === rolePerm.permissionId,
        );
        return {
          ...rolePerm,
          permissionName: matchedPerm ? matchedPerm.permissionName : "zone",
          permissionCategoryName: matchedPerm
            ? matchedPerm.pageCategoryName
            : "",
        };
      });

      const permissionNames = matchedPermissions.map(
        (permission) => permission.permissionName,
      );

      const permissionCategoryNames = matchedPermissions.map(
        (permission) => permission.permissionCategoryName,
      );
      localStorage.setItem("loginPermissions", permissionNames.join(","));
      localStorage.setItem(
        "permissionCategoryNames",
        permissionCategoryNames.join(","),
      );

      //old updateLoginPermission

      // updateLoginPermission(matchedPermissions);
      // navigate("/organization-zone");
      // if (!permissionNames.includes("Zone")) {
      //   // const firstPermission = permissionNames[0]
      //   const nextPermission = findNextPermission(permissionNames)
      //     .toLowerCase()
      //     .replace(/ /g, "-");
      //   navigate(nextPermission);
      //   // navigate(firstPermission);
      // } else {
      // }

      //new updateLoginPermission
      updateLoginPermission(matchedPermissions);

      const nextPermission = findNextPermission(permissionNames);

      // Navigate safely
      navigate(nextPermission);
      const successMessage = userData.message || "LoggedIn Successfully!";
      toast.success(successMessage, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // setSubmissionSuccess(true); // Update submission success state
    } catch (error) {
      if (error.response && error.response.data) {
        const { statusCode, message } = error.response.data;
        toast.error(message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        });
      } else {
        toast.error("An unexpected error occurred. Please try again.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        });
      }
    } finally {
      useCaptchaStore.getState().resetCaptcha();
      setIsLoading(false);
    }
  };

  //old findNextPermission function
  // const findNextPermission = (permissionNames) => {
  //   // Loop through the permissions and find the first one that exists in the valid paths
  //   for (const permission of permissionNames) {
  //     const formattedPermission = permission.toLowerCase().replace(/ /g, "-");
  //     if (validPaths.includes(`/${formattedPermission}`)) {
  //       return formattedPermission;
  //     }
  //   }
  //   // If no valid permission is found, return a default path
  //   return "/";
  // };

  //New findNextPermission function
  //aug
  // const findNextPermission = (permissionNames) => {
  //   const hasScvDashboardPermission =
  //     permissionNames.includes("Primary Deployment") ||
  //     permissionNames.includes("SCVs Dashboard");

  //   if (hasScvDashboardPermission && validPaths.includes("/scv-dashboard")) {
  //     return "/scv-dashboard";
  //   }

  //   for (const permission of permissionNames) {
  //     const formattedPermission =
  //       "/" + permission.toLowerCase().replace(/ /g, "-");

  //     // Check if route exists
  //     if (validPaths.includes(formattedPermission)) {
  //       return formattedPermission;
  //     }
  //   }

  //   // fallback route
  //   return "/scv-dashboard";
  // };

  const findNextPermission = (permissionNames) => {
  const hasPrimaryDashboardPermission =
    permissionNames.includes("Primary Deployment") ||
    permissionNames.includes("SCVs Dashboard");

  if (
    hasPrimaryDashboardPermission &&
    validPaths.includes("/primary-dashboard-overview")
  ) {
    return "/primary-dashboard-overview";
  }

  for (const permission of permissionNames) {
    const formattedPermission =
      "/" + permission.toLowerCase().replace(/ /g, "-");

    if (validPaths.includes(formattedPermission)) {
      return formattedPermission;
    }
  }

  // Fallback route
  return "/primary-dashboard-overview";
};

  return (
    <div className={`login-screen ${isProd ? "ghmc-true" : "ghmc-false"}`}>
      <header className="login-page-heading">
        SOLID WASTE MANAGEMENT APPLICATION
      </header>

      <div
        className="login-page"
        style={{ backgroundImage: `url(${loginBgImage})` }}
      >
        <img
          src={LeftLogo}
          alt=""
          className="login-left-art"
          aria-hidden="true"
        />
        <img
          src={dustbinLogo}
          alt=""
          className="login-dustbin-art"
          aria-hidden="true"
        />

        <div className="login-page-content row g-0">
          <div className="l-block col-lg-7 col-md-6" />

          <div className="r-block col-lg-5 col-md-6">
            <div className="login-brand-logos">
              <img src={logo1} alt="Municipal Corporation of Delhi" />
              <span className="login-logo-divider" aria-hidden="true" />
              <img src={loginLogo} alt="CORE Solid MSW Solution" />
            </div>

            <div className="login-glass-card">
              <h2>Sign in</h2>
              <form onSubmit={handleSubmit}>
                <div className="login-field-group">
                  <label htmlFor="loginEmail" className="login-field-label">
                    Email
                  </label>
                  <input
                    id="loginEmail"
                    type="email"
                    className={`login-field${fieldErrors.emailId ? " login-field--error" : ""}`}
                    placeholder="Enter Your Email"
                    value={credentials.emailId}
                    name="emailId"
                    onChange={handleInputChange}
                    autoFocus
                  />
                  {fieldErrors.emailId ? (
                    <div className="login-field-error">{fieldErrors.emailId}</div>
                  ) : null}
                </div>

                <div className="login-field-group">
                  <label htmlFor="loginPassword" className="login-field-label">
                    Password
                  </label>
                  <div className="login-password-wrap">
                    <input
                      id="loginPassword"
                      type={showPassword ? "text" : "password"}
                      className={`login-field login-field--password${fieldErrors.password ? " login-field--error" : ""}`}
                      placeholder="Password"
                      name="password"
                      value={credentials.password}
                      onChange={handleInputChange}
                      maxLength={20}
                    />
                    <span
                      className="login-password-toggle"
                      onClick={handleTogglePassword}
                    >
                      <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                    </span>
                  </div>
                  {fieldErrors.password ? (
                    <div className="login-field-error">{fieldErrors.password}</div>
                  ) : null}
                </div>

                <Captcha />

                <button
                  type="submit"
                  data-sitekey="6LdRn8UpAAAAADK6zJMzhFZg45cskLczUtAzxZ70"
                  className={`btn btn-block ${isProd ? "btn-blue" : "btn-red"}${isLoading ? " btn-loading" : ""}`}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="btn-spinner">
                      <span className="btn-dots">
                        <span /><span /><span />
                      </span>
                    </span>
                  ) : (
                    "Sign in"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
